import Vue from 'vue'
import Router from 'vue-router' 
import Home from './pages/home'
Vue.use(Router)


export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home, 
    },
    {
      path: '/home/:id',
      name: 'home',
      component: Home,  
    },
    
    
  ]
})